export const FALLBACK_IMAGE = '/no-image.png'